<template>
  <div v-if="stablebao_status==1">
    <van-nav-bar
      title="稳定币基金(GCNY)"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="backgroud">
        <br>
        <van-row style="margin-top: -10px;">
          <van-col span="4"> </van-col>
          <van-col span="10">
            <div class="capital-box" >
              <div class="capital-header" style="margin-left:-40px;">
                <img src="../assets/images/timebao.png" alt="">
                <h5>基金账户余额</h5>
              </div>
            </div>
          </van-col>
          
          <van-col span="1">&nbsp;</van-col>
          <van-col span="9"
            ><div class="capital-box">
              <router-link to="/member/stable_coinbao_user_product_list"
                ><h5 style="color: #0D268D;margin-left:-40px;">持仓列表 ></h5>
                </router-link
              >
            </div></van-col
          >
        </van-row>
         <van-row>
          <van-col span="4"> </van-col>
          <van-col span="10">
            <div class="capital-box" style="margin-left:-40px;">
              <p style="width:200px">{{ stable_account_balance }} GCNY</p>
            </div>
          </van-col>
        
          <van-col span="1"></van-col>
            <van-col span="9"
            ><div class="capital-box">
               <router-link to="/member/Stable_coinbao_flowlog"
                ><h5 style="color: #0D268D;margin-left:-40px;">交易订单 ></h5>
                </router-link
              >
            </div></van-col>

        </van-row>


        <van-row>

          <van-col span="4"> </van-col>
          <van-col span="10">
            <div class="capital-box" >
              <div class="capital-header" style="margin-left:-40px;">
                <img src="../assets/images/timebao.png" alt="">
                <h5>申购额度</h5>
              </div>
            </div>
          </van-col>
          
          <van-col span="1"></van-col>
            <van-col span="8"
            ><div class="capital-box">
               <router-link to="/member/Stable_available_credit_details"
                ><h5 style="color: #0D268D">申购额度明细 ></h5>
                </router-link
              >
            </div></van-col>

        </van-row>



         <van-row>

          <van-col span="4"> </van-col>
          <van-col span="10">
            <div class="capital-box" style="margin-left:-40px;">
              <p style="width:200px">{{ stable_account_avaialble_balance }} GCNY</p>
            </div>
          </van-col>
        
          <van-col span="1"></van-col>
            <van-col span="6"
            ><div class="capital-box">
                <router-link to="/member/stable_description"
                ><h5 style="color: #0D268D">基金说明 ></h5>
                </router-link
              >
            </div></van-col>

        </van-row>
      </div>
      <br>
     <div class="capital-btn">
      <van-row>
         <van-col span="8">
            <van-button
              round
              class="button-in"
              type="danger"
              size="normal"
              @click="moveInState = true;"
              style="height: 30px; width: 80px"
              >转入</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              round
              class="button-out"
              type="info"
              size="normal"
              @click="moveOutState = true;"
              style="height: 30px; width: 80px"
              >转出</van-button
            >
          </van-col>
            <van-col span="8">
            <h5 style="margin-top:5px;">GCNY:元=1:1</h5>
        </van-col>
      
      </van-row>
     </div>
          <div class="capital-btn">

          <van-row>
              <van-col span="8">
          <div class="capital">
            <h5>总持仓(GCNY)</h5>
            <p>{{ total_product_amount }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>最新日收益(GCNY)</h5>
            <p>{{ today_interest_amount }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>总收益（GCNY)</h5>
            <p>{{ total_interest_amount }}元</p>
          </div>
        </van-col>
      </van-row>
          </div>
    <div class="product_lists"

      v-for="(item, index) in stableProductLists"
      :key="index"
    >
      <div>
        <p style="margin-bottom:-10px;margin-top:-5px;">{{ item.name }}</p>
        <p style="margin-bottom:-10px;">{{ item.hours }} </p>
        <p style="margin-bottom:-5px">收益 {{ item.interest_amount }} %</p>
      </div>
      <div class="buy_button">
 <van-button
              round
              class="button-in"
              type="info"
              size="normal"
              @click="openBuyProductPopup(item)"
              style="height: 30px; width: 60px"
              >买入</van-button
            >      </div>
    </div>
          <img :src="stablebaoImage" style="width: 95%;padding: 10px;"/>

    </van-pull-refresh>

    <!-- ==================== move IN confirm popup ========================== -->

    <van-dialog
      v-model="moveInState"
      title="转入到稳定币基金"
      show-cancel-button
      :beforeClose="moveinBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">账户余额:</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ cash }} GCNY
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="moveInAmount"
          label="转入金额:"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>

    <!-- ==================== move OUT confirm popup ========================== -->

    <van-dialog
      v-model="moveOutState"
      title="从稳定币基金转出"
      show-cancel-button
      :beforeClose="moveoutBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">可转余额:</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ stable_account_balance }}元
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="moveOutAmount"
          label="转出金额:"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>
     <!-- ==================== buy product confirm popup ========================== -->

    <van-dialog
      v-model="buyProductState"
      title="买入产品"
      show-cancel-button
      :beforeClose="buyProduct"
    >
    <div>
    <van-row style="padding-left: 15px;font-size:14px">
        <van-col span="24"
          ><div class="buy-info">
            产品 : {{ buyProductName }}元
          </div></van-col
        >
          <van-col span="24"
          ><div class="buy-info">
           期间 : {{ buyProductDuration }}
          </div></van-col
        >
        <van-col span="24"
          ><div class="buy-info">
           收益 : {{ buyProductInterest }}%
          </div></van-col
        >
      </van-row>
    </div>
      <van-cell-group>
        <van-field
          type="number"
          v-model="buyProductAmount"
          label="请输入金额 (GCNY):"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "StableCoinbao",
  data() {
    return {
      isLoading: false,
      amount: 0,
      annual_interest_rate: 0,
       stable_account_balance:0,
       stable_account_avaialble_balance:0,
       stable_account_buyable_balance:0,
       total_product_amount:0,
        total_interest_amount:0,
        today_interest_amount:0,
        moveInAmount:null,
        moveOutAmount:null,
        moveInState:false,
        moveOutState:false,
        buyProductState:false,
        buyProductAmount:null,
        productId:null,
        buyProductName:null,
        buyProductDuration:null,
        buyProductInterest:null,
        cash:0,
        stableProductLists:[],
        stablebao_status:0,
        stablebao_funding_description:'',
        stablebaoImage:''
    };
  },
  computed: {},
  methods: {
     getStablebaoImage() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_image",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebaoImage = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
        openBuyProductPopup(productInfo){
          this.productId=productInfo.id;
          this.buyProductName=productInfo.name;
          this.buyProductDuration=productInfo.hours;
          this.buyProductInterest=productInfo.interest_amount;
          this.buyProductState=true;
        },

   buyProduct(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.buyProductAmount;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                    action: 'buy_coinbao_product',
                    product_id:that.productId,
                    amount:that.buyProductAmount
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                        that.buyProductState = false;
                    that.buyProductAmount=null;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }
          break;
        case "cancel":
          that.buyProductAmount=null;
          done();
          break;
      }
    },
    
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    mainMethod() {
      this.getStableCoinbaoFund();
      this.getUserinfo();
    },
    onRefresh() {
      this.mainMethod();
      this.isLoading = false;
    },
  getStableCoinbaoFund() {
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                nozzle: "stable_coinbao_fund",
                token: sessionStorage.getItem("token"),
                action: 'funds_product_list'
                }
            })
            .then(function (res) {
                if (res.data.code == 1) {
                let resData = res.data;
                that.stable_account_balance = resData.data.stable_account_balance;
                that.total_product_amount = resData.data.total_product_amount;
                that.total_interest_amount = resData.data.total_interest_amount;
                that.today_interest_amount = resData.data.today_interest_amount;
                that.stable_interest_rate = resData.data.stable_interest_rate;
                that.stableProductLists = resData.data.product_lists;
                that.user_account_balance=resData.data.user_account_balance;
                that.stable_account_avaialble_balance=resData.data.stable_account_avaialble_balance;
                that.stable_account_buyable_balance=resData.data.stable_account_buyable_balance;
                } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
                }
            });
      },

    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    moveinBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.moveInAmount;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "movein",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.moveInAmount = null;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }

          break;
        case "cancel":
          that.moveInAmount=null;
          done();
          break;
      }
    },

    moveoutBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.moveOutAmount;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "moveout",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.moveOutAmount = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }
          break;
        case "cancel":
          that.moveOutAmount=null;
          done();
          break;
      }
    },
     getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebao_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
  },
  mounted() {
    this.getStableCoinbaoFund();
    this.getUserinfo();
    this.getSysConfig();
    this.getStablebaoImage();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  /* font-weight: 300; */
  color: #000000;
}

.capital p {
  margin: 0;
  color: #D02E27;
  font-size: 14px;
  font-weight: bold;
}

.capital-box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital-box h5 {
  margin: 0;
  font-size: 16px;
  /* font-weight: 300; */
  color: #000000;
}

.capital-box p {
  margin: 0;
  color: #D02E27;
  font-size: 18px;
  font-weight: bold;
}
.capital-btn {
  margin-top: 10px;
  text-align: center;
}
.capital-header {
  display: flex;
  align-items: center; /* Align items in the same line */
  width:200px;
}

.capital-header img {
  width: 25px;  
  height: 25x; 
  margin-right: 5px; 
  margin-top: -2px;
}

.backgroud {
    margin:10px 10px 5px 10px !important;
    border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
    /* overflow: hidden; */
    height: 170px;
  }
.button-in{
  background-color: #D02E27 !important;
  border: 1px solid #D02E27!important;
}
.button-out{
  background-color: #0D268D !important;
  border: 1px solid #0D268D!important;
}
.buy_button{
float:right !important;
margin-top:-50px;
}
.product_lists{
  padding:16px;
   border:1px solid #e3e3e3!important;
    border-radius: 20px !important;
     margin:10px 10px 10px 10px !important;
}
.buy-info {
  margin: 4px 0;   /* 👈 change this value */
  line-height: 1.5;
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/StableCoinbao.vue